export enum UserRole {
    None = 0,
    Administrator = 1,
    Manager = 2,
    Inspector = 4,
    ReportViewer = 8,
    VideoViewer = 16,
    VideoManager = 32,
    All = Administrator | Manager | Inspector | ReportViewer | VideoViewer | VideoManager
}
